import { render, staticRenderFns } from "./DashboardConfig.vue?vue&type=template&id=3d522a8e"
import script from "./DashboardConfig.vue?vue&type=script&lang=js"
export * from "./DashboardConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports